import { withInstall } from '@zoryn/utils'
import Space from './src/space'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZSpace: SFCWithInstall<typeof Space> = withInstall(Space)
export default ZSpace

export * from './src/space'
export * from './src/item'
export * from './src/use-space'
